import React from 'react'
import { Box } from '@fundamentals'
import { RenderAnswers } from '@elements/Questions/RenderAnswers'
import { Checklist } from '@core/entities/checklist/Checklist'
import { localizedStrings } from '@core/strings'

type ChecklistQuestionsTabProps = {
  checklist: Checklist
}

export const ChecklistTab: React.FC<ChecklistQuestionsTabProps> = ({
  checklist,
}) => {
  const warnings = checklist?.warnings || []

  return (
    <Box flex={1}>
      <RenderAnswers
        questionBuilderAnswers={checklist?.mainAnswers}
        organisationId={checklist?.organisationId}
        warnings={warnings}
      />
      {checklist?.approvalReviews?.approvals?.map(({ approval }) => (
        <RenderAnswers
          key={approval.id}
          questionBuilderAnswers={approval?.approvalAnswers}
          organisationId={checklist?.organisationId}
          warnings={warnings}
          titlePrefix={localizedStrings.approval}
        />
      ))}
    </Box>
  )
}
